module.exports = "/_next/static/images/540dfd2f628706e4862af8e9771f95bb-monthly-payments-xs.jpg";